module.exports = __webpack_public_path__ + "122479caf58128e8e3427fdc3cf59e14.woff2";